




































import { Prop, PropSync, Component, Vue } from 'vue-property-decorator'

@Component
export default class Confirm extends Vue {
  @Prop({ type: String, required: false, default: 'top center' }) position!: string
  @Prop({ type: String, required: false, default: 'slide-fade-up' }) transition!: string
  @Prop({ type: String, required: false, default: 'primary' }) color!: string

  @Prop({ type: String, required: false, default: '' }) title!: string
  @Prop({ type: String, required: false, default: '' }) text!: string

  @PropSync('visible', { type: Boolean, required: true, default: false }) visibleSync!: boolean

  positions: string[] = this.position.split(' ')
}
